import { NewStudyKind, StudyGroupKind } from '@components/StudiesApp/components/StudyNew/types';

export const STUDY_TYPE_OPTIONS: { label: string; key: StudyGroupKind }[] = [
  { label: 'Moderated', key: 'moderated' },
  { label: 'Unmoderated', key: 'unmoderated' },
  { label: 'Surveys & other', key: 'other' }
];

export const STUDY_TYPE_KINDS_BY_KEY: Record<StudyGroupKind, NewStudyKind[]> = {
  moderated: ['video_call', 'focus_groups', 'round_robin', 'collective', 'continuous'],
  unmoderated: ['prototype_test', 'card_sort', 'tree_test', 'ai_moderation'],
  other: ['survey', 'panel', 'online_task']
};

export const SLIDEOUT_BUTTON_KINDS: Partial<NewStudyKind>[] = [
  'video_call',
  'focus_groups',
  'survey',
  'unmoderated_test',
  'online_task',
  'panel'
];

export const NEW_STUDY_PALETTE = {
  video_call: '#3A77F0',
  focus_groups: '#9F46F4',
  round_robin: '#E02424',
  collective: '#057A55',
  continuous: '#48DAFD',
  survey: '#FB542A',
  prototype_test: '#131128',
  unmoderated_test: '#131128',
  card_sort: '#FF4BA6',
  tree_test: '#A4508B',
  five_second_test: '#FFA800',
  preference_test: '#19DB7E',
  first_click_test: '#ACE60F',
  online_task: '#1A8896',
  panel: '#4D47E1'
};
